import React, { FC, ImgHTMLAttributes, useEffect, useState } from 'react';

import cx from 'classnames';

import './style.scss';

export interface ILazyImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  preview?: string;
  alt: string;
  inView: boolean;
}

const PreviewImage: FC<ILazyImageProps> = ({ className, preview, src, alt, inView, ...rest }) => {
  const [isLoading, setLoading] = useState(!!preview);
  const BLUR_CLASS = 'LazyImage--blur';

  useEffect(() => {
    if (inView) {
      setLoading(false);
    }
  }, [src, setLoading, inView]);

  const srcToShow = preview && isLoading ? preview : src;

  return (
    <img
      className={cx('LazyImage', className, { [BLUR_CLASS]: isLoading })}
      src={srcToShow}
      alt={alt}
      {...rest}
    />
  );
};

export default PreviewImage;
